import withCellPopover from '../../withCellPopover';

// Components
import { Select } from '../../advancedSelect';

// Containers
import makeCellRenderer from '../containers/makeCellRenderer';
var SelectInputCellRenderer = makeCellRenderer(withCellPopover(Select));
export default SelectInputCellRenderer;